export default "__VITE_ASSET__CAFOGmCk__"